import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {isProd} from "src/utils/detectEnv";

export type regionDisplayState = {
    displayedRegion: string,
    settingsEnabled: boolean,
};

const initialState: regionDisplayState = {
    displayedRegion: "",
    settingsEnabled: true
};

export const getDisplayedRegion = createAsyncThunk("region/getDisplayedRegion", async () => {
    const region: string = "us-east-1";
    let displayedRegion = "NA";
    switch(region) {
      case "eu-west-1": {
          displayedRegion = "EU";
          break;
      }
      case "ap-northeast-1": {
          displayedRegion = "RoW";
          break;
      }
      default: {
          displayedRegion = "NA";
      }
    }
    return displayedRegion;
});

const {reducer, actions} = createSlice({
    name: "regionDisplaySlice",
    initialState,
    reducers: {
        setSettingsEnabled: (state, action) => {
            const displayedRegion = action.payload.displayedRegion;
            const isSettingsParamEnabled = action.payload.isSettingsParamEnabled;
            state.settingsEnabled = true
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getDisplayedRegion.fulfilled, (state, {payload}) => {
            state.displayedRegion = payload;
        });
    }
});

export const {setSettingsEnabled} = actions;

export default reducer;
